import type { Doc } from "building-types/doc";
import type { DocEntityHandle, RoomLayoutHandle } from "building-types/handles/docEntityHandleTypes";
import { assertIsNotUndefined } from "common/utils/assertOfType";
import { docEntityHandleHash } from "./entity/core/handleHash";
import { isRoomLayoutEligibleDocEntityHandle } from "./rooms/layout/roomLayoutEligibleEntityTypes";

export function docEntityIsInRoomLayout(doc: Doc, handle: DocEntityHandle) {
  if (!isRoomLayoutEligibleDocEntityHandle(handle)) {
    return false;
  }

  const hash = docEntityHandleHash(handle);
  return !!doc.entityRoomLayouts[hash];
}

export function docEntityGetRoomLayout(doc: Doc, handle: DocEntityHandle): RoomLayoutHandle | undefined {
  if (!docEntityIsInRoomLayout(doc, handle)) {
    return undefined;
  }

  const hash = docEntityHandleHash(handle);
  const roomLayoutId = doc.entityRoomLayouts[hash];
  assertIsNotUndefined(roomLayoutId);

  return { type: "ROOM_LAYOUT", id: roomLayoutId };
}
